module.exports = __webpack_public_path__ + "front/img/3_a.f461c855.png";